import "core-js/modules/es6.object.to-string.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.filter.js";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { EventEmitter } from 'events';
import Vue from 'vue';
var API_URL = 'https://www.google.com/recaptcha/api.js';
var ReCaptcha = /*#__PURE__*/function () {
  function ReCaptcha(_ref) {
    var hideBadge = _ref.hideBadge,
      language = _ref.language,
      siteKey = _ref.siteKey,
      version = _ref.version;
    _classCallCheck(this, ReCaptcha);
    if (!siteKey) {
      throw new Error('ReCaptcha error: No key provided');
    }
    if (!version) {
      throw new Error('ReCaptcha error: No version provided');
    }
    this._elements = {};
    this._eventBus = null;
    this._ready = false;
    this.hideBadge = hideBadge;
    this.language = language || 'en';
    this.siteKey = siteKey;
    this.version = version;
  }
  _createClass(ReCaptcha, [{
    key: "destroy",
    value: function destroy() {
      if (this._ready) {
        this._ready = false;
        var _document = document,
          head = _document.head;
        var style = this._elements.style;
        var scripts = _toConsumableArray(document.head.querySelectorAll('script')).filter(function (script) {
          return script.src.includes('recaptcha');
        });
        if (scripts.length) {
          scripts.forEach(function (script) {
            return head.removeChild(script);
          });
        }
        if (head.contains(style)) {
          head.removeChild(style);
        }
      }
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.init();
            case 3:
              if (!('grecaptcha' in window)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", window.grecaptcha.execute(this.siteKey, {
                action: action
              }));
            case 5:
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              throw new Error('ReCaptcha error: Failed to execute');
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7]]);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "getResponse",
    value: function getResponse() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        if ('grecaptcha' in window) {
          var response = window.grecaptcha.getResponse();
          if (response) {
            _this._eventBus.emit('recaptcha-success', response);
            resolve(response);
          } else {
            var errorMessage = 'Failed to execute';
            _this._eventBus.emit('recaptcha-error', errorMessage);
            reject(errorMessage);
          }
        }
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      if (this._ready) {
        return Promise.resolve();
      }
      this._eventBus = new EventEmitter();
      this._elements = {
        script: document.createElement('script'),
        style: document.createElement('style')
      };
      var _this$_elements = this._elements,
        script = _this$_elements.script,
        style = _this$_elements.style;
      script.addEventListener('error', function () {
        document.head.removeChild(script);
        throw new Error('ReCaptcha error: Failed to load script');
      });
      script.setAttribute('async', '');
      script.setAttribute('defer', '');
      if (this.version === 2) {
        script.setAttribute('src', API_URL + '?hl=' + this.language);
      } else {
        script.setAttribute('src', API_URL + '?render=' + this.siteKey);
      }
      document.head.appendChild(script);
      window.recaptchaSuccessCallback = function (token) {
        return _this2._eventBus.emit('recaptcha-success', token);
      };
      window.recaptchaExpiredCallback = function () {
        return _this2._eventBus.emit('recaptcha-expired');
      };
      window.recaptchaErrorCallback = function () {
        return _this2._eventBus.emit('recaptcha-error', 'Failed to execute');
      };
      this._ready = new Promise(function (resolve) {
        script.addEventListener('load', function () {
          if (_this2.version === 3 && _this2.hideBadge) {
            style.innerHTML = '.grecaptcha-badge { display: none }';
            document.head.appendChild(style);
          }
          window.grecaptcha.ready(resolve);
        });
      });
      return this._ready;
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      return this._eventBus.on(event, callback);
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.version === 2) {
        window.grecaptcha.reset();
      }
    }
  }]);
  return ReCaptcha;
}();
export default function (_, inject) {
  Vue.component('recaptcha', function () {
    return import('./recaptcha.vue');
  });
  inject('recaptcha', new ReCaptcha({
    "hideBadge": true,
    "siteKey": "6LcRzQAVAAAAAI01JVs0US9Wke_KJqDofx8-KLMO",
    "version": 3
  }));
}